import React, { useContext, useEffect, useState } from 'react'
import { getImages } from '../Common/const'
import UploadDocument from './UploadDocument';
import { VehicleContext } from '../Context/VehicleContext';

const AddVehicle = ({ close, handleAddVehicle, selectedVehicle }) => {

    const {validateVIN, vehicleDecode, addInventoryVehicle, getVehicleData} = useContext(VehicleContext);

    const [vinData,setVinData] = useState(null);

    const getVINData = async (vin) => {
        const response = await vehicleDecode(vin);

        if('attributes' in response) {
            setVinData(response.attributes);

            setFormData({
                ...formData,
                ['vin']:response.attributes.VIN,
                ['year']:response.attributes.Year,
                ['make']:response.attributes.Make,
                ['model']:response.attributes.Model,
                ['trim']:response.attributes.Trim,
                ['body_style']:response.attributes['Vehicle Type']
            })

        }
    }

    const [images, setImages] = useState([]);
    const [primaryImage,setPrimaryImage] = useState(null);

    useEffect(() => {
        console.log(images,images.map(item => item.key));
        setFormData({
            ...formData,
            "photos":images.map(item => item.key)
        });
    },[images]);
    
    const [formData, setFormData] = useState({
        vin:'',
        year:'',
        make:'',
        model:'',
        trim:'',
        body_style:'',
        mileage:'',
        transmission:'',
        exterior_color:'',
        interior_color:'',
        price:'',
        stockno:'',
        description:'',
        photos:[]
    });

    const onChangeInput = (e) => {

        if(e.target.name == "vin" && validateVIN(e.target.value)) {
            getVINData(e.target.value);
        } else {
            setFormData({
                ...formData,
                [e.target.name]:e.target.value
            })
        }
    }

    const submitForm = async (e) => {
        e.preventDefault();

        console.log(formData);

        const data = await addInventoryVehicle(formData);

        if(data.success) {
            close();
            e.target.reset();

            getVehicleData(true);
        } else {
            alert("Error adding vehicle");
        }
    }

    useEffect(() => {
        if(selectedVehicle && selectedVehicle.vin) {
            console.log(selectedVehicle);

            if(selectedVehicle.images) setImages(selectedVehicle.images.map(item => ({'url':item,'key':getFilePathOnly(item)})));

            if(selectedVehicle.vdp_hero_image) setPrimaryImage({'url':selectedVehicle.vdp_hero_image});

            setFormData({
                vin:selectedVehicle.vin,
                year:selectedVehicle.year,
                make:selectedVehicle.make,
                model:selectedVehicle.model,
                trim:selectedVehicle.trim,
                body_style:selectedVehicle.body_style,
                mileage:selectedVehicle.mileage,
                transmission:selectedVehicle.transmission,
                exterior_color:selectedVehicle.exterior_color,
                interior_color:selectedVehicle.interior_color,
                price:selectedVehicle.price,
                stockno:selectedVehicle.stockno,
                description:selectedVehicle.description,
                photos:[]
            });
        }
    },[selectedVehicle]);

    const getFilePathOnly = (url) => {
        try {
            const urlObject = new URL(url);

            return urlObject.pathname;
        } catch (error) {
            console.error("Invalid URL:", error);
            return null; // Handle invalid URL gracefully
        }
    }

    return (
        <>
            <div className="modal-content">
                <div className="modal-header">
                    <h1 className="modal-title filter-modal-title w-100 text-center">
                        Add Vehicle
                    </h1>
                    <button className="sm-box-close" type="button" onClick={close}>
                        <img src={getImages('white-close.svg')} />
                    </button>
                </div>
                <div className="modal-body p-0">
                    <form onSubmit={submitForm} method="post">
                        <input type="hidden" name="photos" value={formData.photos} />
                        <div className='admin-modal-box'>
                            <div className='admin-black-box p-5'>
                                <div className='md-title text-uppercase mb-4'>Add Vehicle</div>
                                <div className='admin-custom-form custom-form row'>
                                    <div className='col-md-12 mb-3'>
                                        <div className='row'>
                                            <div className='col-md-8'>
                                                <label className='cs-label'>VIN Number</label>
                                                <div className='position-relative'>
                                                    <input type="text" name='vin' className='form-control vin-control pe-5' value={formData.vin} onChange={onChangeInput}/>
                                                    {(vinData || selectedVehicle.vin) && (
                                                        <span className='vin-check-icon'>
                                                            <img src={getImages('check-green.svg')} />
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="text-start tip-text mt-2">Tip: Enter VIN and we’ll pre-fill the rest for you.</div>
                                    </div>
                                    <div className='col-md-4 mb-3'>
                                        <label className='cs-label'>Year</label>
                                        <input type="text" name="year" className='form-control' value={formData.year} onChange={onChangeInput} />
                                        {/*<select name='year' className='form-control'>
                                            <option>Select</option>
                                            <option>2025</option>
                                            <option>2024</option>
                                            <option>2023</option>
                                            <option>2022</option>
                                        </select>*/}
                                    </div>
                                    <div className='col-md-4 mb-3'>
                                        <label className='cs-label'>Make</label>
                                        <input type="text" name="make" className='form-control' value={formData.make} onChange={onChangeInput} />
                                        {/*<select name='make' className='form-control'>
                                            <option>Select</option>
                                            <option>Mercedes</option>
                                        </select>*/}
                                    </div>
                                    <div className='col-md-4 mb-3'>
                                        <label className='cs-label'>Model</label>
                                        <input type="text" name="model" className='form-control' value={formData.model} onChange={onChangeInput} />
                                        {/*<select name='model' className='form-control'>
                                            <option>Select</option>
                                            <option>C-Class</option>
                                            <option>E-Class</option>
                                            <option>S-Class</option>
                                            <option>GLC</option>
                                            <option>GLE</option>
                                        </select>*/}
                                    </div>
                                    <div className='col-md-4 mb-3'>
                                        <label className='cs-label'>Trim</label>
                                        <input type="text" name="trim" className='form-control' value={formData.trim} onChange={onChangeInput} />
                                    </div>
                                    <div className='col-md-4 mb-3'>
                                        <label className='cs-label'>Body Style</label>
                                        <input type="text" name='body_style' className='form-control' value={formData.body_style} onChange={onChangeInput} />
                                    </div>
                                    <div className='col-md-4 mb-3'>
                                        <label className='cs-label'>Mileage</label>
                                        <input type="text" name='mileage' className='form-control' value={formData.mileage} onChange={onChangeInput} />
                                    </div>
                                    <div className='col-md-4 mb-3'>
                                        <label className='cs-label'>Transmission</label>
                                        <select name='transmission' className='form-control' value={formData.transmission} onChange={onChangeInput} >
                                            <option>Select</option>
                                            <option>Manual </option>
                                            <option>Automatic </option>
                                            <option>Semi-Automatic </option>
                                        </select>
                                    </div>
                                    <div className='col-md-4 mb-3'>
                                        <label className='cs-label'>Exterior Color</label>
                                        <input type="text" name='exterior_color' className='form-control' value={formData.exterior_color} onChange={onChangeInput} />
                                    </div>
                                    <div className='col-md-4 mb-3'>
                                        <label className='cs-label'>Interior Color</label>
                                        <input type="text" name='interior_color' className='form-control' value={formData.interior_color} onChange={onChangeInput} />
                                    </div>
                                    <div className='col-md-4 mb-3'>
                                        <label className='cs-label'>Price</label>
                                        <input type="text" name='price' className='form-control' value={formData.price} onChange={onChangeInput} />
                                    </div>
                                    <div className='col-md-4 mb-3'>
                                        <label className='cs-label'>Stock Number</label>
                                        <input type="text" name='stockno' className='form-control' value={formData.stockno} onChange={onChangeInput} />
                                    </div>
                                    <div className='col-12 mb-3'>
                                        <label className='cs-label'>Vehicle Description</label>
                                        <textarea name='description' className='form-control h-100px' value={formData.description} onChange={onChangeInput} />
                                    </div>
                                    <div className='col-12 mt-5 mb-4'>
                                        {(vinData || selectedVehicle.vin) && <UploadDocument
                                            vin={formData.vin}
                                            images={images}
                                            setImages={setImages}
                                            primaryImage={primaryImage}
                                            setPrimaryImage={setPrimaryImage}
                                        />}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='admin-modal-footer d-flex align-items-center justify-content-center'>
                            {/*<div className='me-4'>
                                <button type='submit' onClick={handleAddVehicle} className='fl-transparent-btn px-4'>Save and Add Another Vehicle</button>
                            </div>*/}
                            <div>
                                <button type='submit' className='black-btn admin-sm-btn'>Save</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}

export default AddVehicle